import { render, staticRenderFns } from "./MemberViewExams.vue?vue&type=template&id=ad5a3caa&"
import script from "./MemberViewExams.vue?vue&type=script&lang=js&"
export * from "./MemberViewExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports